import "./CartItem.css";
import { motion } from "framer-motion";
import { useState } from "react";

const CartItem = ({ id, item, onRemove, handleAmountChange }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [amount, setAmount] = useState(1);

    // --- LOGICA SCONTO ---
    const price = parseFloat(item.price);
    const salePrice = item.sale_price ? parseFloat(item.sale_price) : null;
    const isOnSale = salePrice !== null && salePrice < price;
    const discountPercentage = isOnSale ? Math.round(((price - salePrice) / price) * 100) : 0;
    // ---------------------

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    const extractImages = (data) => {
        const images = [];
        const CDN = "https://cdn.psicopaticiservice.com/";
        const main = data?.options?.image;
        if (main && !["null", "undefined"].includes(String(main))) {
            images.push(CDN + main);
        }

        const optCart = data?.options?.options?.optionCartValue;
        if (optCart) {
            // Se optCart è un array (nuovo formato ordinato), usiamo forEach direttamente
            if (Array.isArray(optCart)) {
                optCart.forEach((container) => {
                    Object.values(container).forEach((optionArray) => {
                        optionArray.forEach((option) => {
                            const img = option?.image;
                            if (img && !["null", "undefined"].includes(String(img))) {
                                images.push(CDN + img);
                            }
                        });
                    });
                });
            } else {
                // Vecchio formato oggetto
                Object.values(optCart).reverse().forEach((optionArray) => {
                    optionArray.forEach((option) => {
                        const img = option?.image;
                        if (img && !["null", "undefined"].includes(String(img))) {
                            images.push(CDN + img);
                        }
                    });
                });
            }
        }
        return images;
    };

    const extractOptions = (data) => {
        const optionsList = [];
        const baseValue = data?.options?.base?.value;
        const baseName = data?.options?.base?.name || "Base";
        if (baseValue) {
            optionsList.push({ name: baseName.split("-")[0], value: baseValue });
        }
        if (data?.options?.selectedSize) {
            optionsList.push({ name: "Taglia", value: data.options.selectedSize });
        }

        const info = data?.options?.options?.optionInfo;
        const cart = data?.options?.options?.optionCartValue;
        const baseOptId = data?.options?.base?.option_id;

        if (info && cart) {
            Object.entries(info).forEach(([optId, label]) => {
                if (baseOptId != null && String(optId) === String(baseOptId)) return;
                
                // Gestione sia per array che per oggetto
                let selectedOption;
                if (Array.isArray(cart)) {
                    const found = cart.find(obj => obj[optId]);
                    selectedOption = found ? found[optId][0]?.option_value : null;
                } else {
                    selectedOption = cart[optId]?.[0]?.option_value;
                }

                if (selectedOption) {
                    optionsList.push({ name: label.split("-")[0], value: selectedOption });
                }
            });
        }
        return optionsList;
    };

    return (
        <div className={"cart-card mb-4"}>
            <div className="row g-3 mt-0">
                <div className={"relative col-5 mt-0 ps-0"} style={{ position: 'relative' }}>

                    
                    {extractImages(item).map((img, index) => (
                        <img
                            key={index}
                            src={img}
                            alt={`img-${index}`}
                            className="cart-image"
                            style={{ zIndex: index }}
                        />
                    ))}
                </div>

                <div className={"col-7 mt-0 pe-0"} style={{ height: "15vh", overflowY: "auto" }}>
                    <h2 className="fw-bold me-0 mt-0" style={{ fontSize: '1.2rem' }}>{item.name}</h2>
                    
                    {/* VISUALIZZAZIONE PREZZO SCONTATO */}
                    <div className="d-flex align-items-baseline gap-2 mt-1">
                        {isOnSale ? (
                            <>
                                <p className={"price fw-bold mb-0"} style={{ color: 'black' }}>
                                    {salePrice.toFixed(2)}€
                                </p>
                                <div className="d-flex gap-1 align-items-center">
                                    <p className={"text-muted mb-0"} style={{ textDecoration: 'line-through', fontSize: '0.85rem' }}>
                                        {price.toFixed(2)}€
                                    </p>
                                
                                    <div style={{
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '0px 6px',
                                        fontSize: '10px',
                                        fontWeight: 'bold',
                                        borderRadius: '2px',
                                        zIndex: 10
                                    }}>
                                        -{discountPercentage}%
                                    </div>
                                </div>
                  
                            </>
                        ) : (
                            <p className={"price fw-bold mb-0"}>{price.toFixed(2)}€</p>
                        )}
                    </div>

                    <div>
                        <div className="mt-2 d-flex align-items-center gap-2" onClick={toggleCollapse} style={{ cursor: 'pointer' }}>
                            <p style={{ marginBottom: "0", fontSize: '0.9rem' }}>Più informazioni</p>
                            <motion.p
                                animate={{ rotate: isCollapsed ? 180 : 0 }}
                                transition={{ duration: 0.3 }}
                                style={{ display: 'inline-block', fontSize: "18px", marginBottom: "0" }}
                            >
                                <i className="fa-solid fa-caret-down"></i>
                            </motion.p>
                        </div>

                        <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: isCollapsed ? "auto" : 0, opacity: isCollapsed ? 1 : 0 }}
                            transition={{ duration: 0.4, ease: "easeInOut" }}
                            style={{ overflow: "hidden" }}
                        >
                            <ul className="list-unstyled text-muted mt-2 mb-2">
                                {extractOptions(item).map((obj, index) => (
                                    <li key={index}>
                                        <p className="mb-0 lista" style={{ fontSize: '0.85rem' }}>• {obj.name}: {obj.value}</p>
                                    </li>
                                ))}
                            </ul>
                        </motion.div>
                    </div>
                </div>
            </div>

            <div className="cart d-flex align-items-center justify-content-end gap-4 mt-2 p-0">
                <button 
                    style={{ minHeight: "35px", fontSize: '0.8rem' }} 
                    className="btn btn-black ps-3 pe-3"
                    onClick={() => onRemove(item.id)}
                >
                    RIMUOVI
                </button>
            </div>
        </div>
    );
};

export default CartItem;